import { LocalStorageService } from "angular-2-local-storage/dist";
import { SearchTableState } from "./search-table-state";
import { IMyDateModel } from "mydatepicker";
declare var jQuery: any;

export abstract class BaseTableComponent {

    constructor(
        private baseLocalStorageService: LocalStorageService,
        public baseSearchTableState?: SearchTableState
    ) {
        if (!baseSearchTableState)
            this.baseSearchTableState = new SearchTableState();
    }

    protected setPageSize(key: string): void {
        if (!this.baseLocalStorageService.isSupported) {
            return;
        }
        let pageSize: string = this.baseLocalStorageService.get(key) as string;
        if (pageSize) {
            this.baseSearchTableState.itemsPerPage = parseInt(pageSize);
        } else {
            this.baseLocalStorageService.set(key, this.baseSearchTableState.itemsPerPage);
        }
    }

    protected setLastRefreshed(key: string): void {
        if (!this.baseLocalStorageService.isSupported) {
            return;
        }
        let lastRefreshed: string = this.baseLocalStorageService.get(key) as string;
        if (lastRefreshed) {
            this.baseSearchTableState.lastRefreshed = new Date(lastRefreshed);
        } else {
            this.updateLastRefreshed(key);
        }
    }

    protected updateLastRefreshed(key: string): void {
        this.baseSearchTableState.lastRefreshed = new Date();
        this.baseLocalStorageService.set(key, this.baseSearchTableState.lastRefreshed);
    }

    protected onFromDateChanged(model: IMyDateModel): void {
        this.baseSearchTableState.fromDate = model.jsdate ? new Date(model.jsdate.getTime() + -1 * (new Date().getTimezoneOffset() * 60000)) : null;
    }

    protected onToDateChanged(model: IMyDateModel): void {
        this.baseSearchTableState.toDate = model.jsdate ? new Date(model.jsdate.getTime() + -1 * (new Date().getTimezoneOffset() * 60000)) : null;
    }

    protected updatePageSize(key: string): void {
        if (this.baseLocalStorageService.isSupported) {
            this.baseLocalStorageService.set(key, this.baseSearchTableState.itemsPerPage);
        }
    }

    protected clearFilterForm(): void {
        this.baseSearchTableState.email = '';
        this.baseSearchTableState.emailCondition = 0;
        this.baseSearchTableState.mobileNumber = '';
        this.baseSearchTableState.mobileNumberCondition = 0;
        this.baseSearchTableState.externalId = ''
        this.baseSearchTableState.externalIdCondition = 0;
        this.baseSearchTableState.fromDate = null;
        this.baseSearchTableState.toDate = null;
        this.baseSearchTableState.siteName = '';
        this.baseSearchTableState.siteNameCondition = 0;
        this.baseSearchTableState.loyaltyTransactionLogId = '';
        this.baseSearchTableState.loyaltyTransactionLogIdCondition = 0;
        this.baseSearchTableState.transactionTypeId = null;
        jQuery('my-date-picker input').val('');
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/admin/base-table.component.ts